import { useNovaApi } from '../useNovaApi';

export const useTermSelect = () => {
  return (
    useNovaApi<Nl.Api.TagTermSelectResponse>('/term/select').data?.terms || []
  );
};
